import { Box, List, ListItem } from '@mui/material';
import Typography from '@mui/material/Typography';
import { InternalLink } from 'components/shared/InternalLink';
import { QueryStateDisplay } from 'components/shared/QueryStateDisplay';
import { useGetData } from 'data/useGetData';
import { getStoryRoute } from 'routes';
import { useStoryRouteParams } from 'routes/useStoryRouteParams';

const NUMBER_TO_SHOW = 10;

export function MoreStoriesWidget() {
  const { storyId } = useStoryRouteParams();

  const getDataState = useGetData();

  if (getDataState.data?.stories === undefined) {
    return <QueryStateDisplay queryState={getDataState} />;
  }

  const moreStories = getDataState.data.stories
    .filter((story) => story.id !== storyId)
    .sort(() => Math.random() - 0.5)
    .slice(0, NUMBER_TO_SHOW);

  if (moreStories.length === 0) {
    return null;
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        More stories
      </Typography>
      <List sx={{ py: 0 }}>
        {moreStories.map(({ id, slug, summary }) => (
          <ListItem key={id}>
            <InternalLink to={getStoryRoute(id, slug)}>{summary}</InternalLink>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
